<template>
  <d2-container>
    <top-line :message="pageTitle" :iconclass="'fa fa-users'"></top-line>
    <el-row class="pagebody">
      <!-- 返回按钮 -->
      <el-row style="margin-bottom: 15px;">
        <el-button type="primary" icon="el-icon-back" size="medium" plain @click="goBack" />
      </el-row>
      <!-- 过滤栏 -->
      <el-row class="filter-bar">
        <el-card shadow="never">
          <el-form :inline="true" :model="searchForm" ref="searchForm" label-width="200px" size="small">
            <el-row >
              <el-col :span="8">
                <el-form-item label="用户：" prop="user" class="search-item" :label-width="labelWidth">
                  <el-input v-model="searchForm.user" style="width:175px" />
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <el-button type="primary" icon="el-icon-search" size="small" plain style="margin-left:8px;"
                           class="fr"
                           @click="handleSearch">
                  查询
                </el-button>
                <el-button type="info" icon="el-icon-refresh-left" size="small" plain style="margin-left:8px;"
                           class="fr"
                           @click="handleReset">
                  重置
                </el-button>
              </el-col>
            </el-row>
          </el-form>
        </el-card>
      </el-row>

      <el-row class="main-table">
        <el-table :data="tableData" border stripe>
          <el-table-column type="index" align="center" width="75px" />
          <!-- <el-table-column prop="id" label="ID" align="center" width="200px" /> -->
          <el-table-column prop="username" label="用户" width="160px" />
          <el-table-column prop="created_at" label="创建时间" width="180px" />
          <el-table-column prop="billing_date" label="计费日期"  width="200px"/>
          <el-table-column prop="app_kind" label="应用类型" width="95px" />
          <el-table-column prop="app_name" label="应用名称" width="200px" />
          <el-table-column prop="deploy_name" label="部署名称" width="200px" />
          <el-table-column prop="model_name" label="显卡型号" width="220px" />
          <el-table-column prop="duration_seconds" label="使用时间（秒）"  width="200px"/>
          <el-table-column prop="cost" label="计费（元）"  width="200px"/>
          <el-table-column prop="price" label="价格（元/秒）"  width="200px"/>
        </el-table>
      </el-row>
      <el-row type="flex" justify="left" style="margin-top: 10px; margin-bottom: 18px;">
        <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page.sync="pagination.page"
            :page-sizes="pagination.pageSizeList"
            :page-size="pagination.pageSize"
            layout="total, sizes, prev, pager, next, jumper"
            :total="pagination.total">
        </el-pagination>
      </el-row>
    </el-row>
  </d2-container>
</template>

<script>

import topLine from "@/components/save-common/topLine.vue";
import commonListMixin from "@/pages/mixin/mixin-common-list";

export default {
  name: "allns",
  mixins: [
    commonListMixin
  ],
  components: {
    topLine,
  },
  data() {
    return {
      pageTitle: "计费明细列表",
      labelWidth: '120px',
      tableDataApi: '/api/billing-details',

      searchForm: {
        user:'',
        start_time:'',
        end_time:'',
        month: '',
      },
      orgParams: {
        page: 1, 
        pageSize: 10,
        total: 0,
      },
      orgDetailParams: {
        page: 1, 
        pageSize: 10,
        total: 0,
      },
      period: [],
      currentRow: {},
    }
  },
  computed: {
  },
  mounted () {
    this.loadParams()
  },
  methods: {
    loadParams () {
      console.log('+++ user-资金详细 +++', this.$route.query)
    
      if('username' in this.$route.query && this.$route.query.username) {
        this.searchForm.user = this.$route.query.username
      }
      if('start_time' in this.$route.query && this.$route.query.start_time) {
        this.searchForm.start_time = this.$route.query.start_time
      }
      if('end_time' in this.$route.query && this.$route.query.end_time) {
        this.searchForm.end_time = this.$route.query.end_time
      }
      if('month' in this.$route.query && this.$route.query.month) {
        this.searchForm.month = this.$route.query.month
      }
      if('orgPage' in this.$route.query && this.$route.query.orgPage) {
        this.orgParams.page = this.$route.query.orgPage
      }
      if('orgPageSize' in this.$route.query && this.$route.query.orgPageSize) {
        this.orgParams.pageSize = this.$route.query.orgPageSize
      }
      if('orgTotal' in this.$route.query && this.$route.query.orgTotal) {
        this.orgParams.total = this.$route.query.orgTotal
      }

      if('orgDetailPage' in this.$route.query && this.$route.query.orgDetailPage) {
        this.orgDetailParams.page = this.$route.query.orgDetailPage
      }
      if('orgDetailPageSize' in this.$route.query && this.$route.query.orgDetailPageSize) {
        this.orgDetailParams.pageSize = this.$route.query.orgDetailPageSize
      }
      if('orgDetailTotal' in this.$route.query && this.$route.query.orgDetailTotal) {
        this.orgDetailParams.total = this.$route.query.orgDetailTotal
      }

    },
    handleReset () {
      this.searchForm = {
        user:'',
        start_time:'',
        end_time:'',
        month: '',
      }
      this.getTableData()
    },
    handleSearch () {
      this.getTableData()
    },
    
    goBack() {
      const backQuery = {
        username: this.searchForm.user,
        // start_time: this.searchForm.start_time,
        // end_time: this.searchForm.end_time,
        page: this.orgDetailParams.page,
        pageSize: this.orgDetailParams.pageSize,
        total: this.orgDetailParams.total,
        orgPage: this.orgParams.page,
        orgPageSize: this.orgParams.pageSize,
        orgTotal: this.orgParams.total
      };

      // 自动推断 month 字段：使用 start_time 所属的月份
      if (this.searchForm.start_time) {
        const date = new Date(this.searchForm.start_time);
        const year = date.getFullYear();
        const month = String(date.getMonth() + 1).padStart(2, '0'); // 月份补零
        backQuery.month = `${year}-${month}`;
      }

      this.$router.push({
        path: '/user-billing-day',
        query: backQuery
      });
    },
  }

}
</script>

<style scoped lang="scss">
.pagebody {
  margin-top: 20px;
  margin-left: 20px;
}
.filter-bar {
  margin-bottom: 10px;
}
.main-table {
  margin-top: 10px;
}

.search-button-line {
  display: flex;
  justify-content: flex-end;
}
.batch-button {
  min-width: 95px;
}
</style>
